export default __webpack_public_path__ + "static/service_banner_shape_2-61e1f037717c185408e7ac13a862973d.png";